export default __webpack_public_path__ + "static/media/icon-burger.dc469141.svg";